import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import LabelStudioUI from '../LabelStudioUI';
import BoundingBox from '../../../common/BoundingBox';
import './styles.scss';

function generatePreAnnotations(litterData) {
    const result = litterData.map((litter) => {
        const box = litter.box;
        const x = box[0][0] * 100.0;
        const y = box[0][1] * 100.0;
        const width = (box[1][0] - box[0][0]) * 100.0;
        const height = (box[1][1] - box[0][1]) * 100.0;
        let outputAnnotations = [];

        // add base tag from_name annotation
        let annotation = {
            from_name: 'tag',
            id: litter.litterId ? litter.litterId.toString() : 0,
            source: '$image',
            to_name: 'img',
            type: 'rectanglelabels',
            value: {
                rectanglelabels: ['Litter'],
                rotation: 0,
                x,
                y,
                width,
                height,
            },
        };
        outputAnnotations.push(annotation);

        if (litter.userTags) {
            const objectAnnotation = {
                from_name: 'tags',
                id: litter.litterId ? litter.litterId.toString() : 0,
                source: '$image',
                to_name: 'img',
                type: 'textarea',
                value: {
                    text: litter.userTags,
                    rectanglelabels: ['Litter'],
                    rotation: 0,
                    x,
                    y,
                    width,
                    height,
                },
            };
            outputAnnotations.push(objectAnnotation);
        }

        return outputAnnotations;
    });

    return result.flat();
}

function ImageCard(props) {
    const [open, setOpen] = useState(false);
    const litterCount =
        props.data.litters.length > 0 ? props.data.litters.length : 0;
    const createdDate = new Date(props.data.createdAt).toString();
    const latLong = props.data.location.coordinates.join();
    const city = props.data && props.data.city ? props.data.city : '';
    const country = props.data && props.data.country ? props.data.country : '';

    const imageThumbnail = props.data.thumbnail;

    // format bounding box data to format for labelStudioUI
    const boundingBoxData = props.data.litters.map((litter) => {
        return {
            litterId: litter.litterId,
            box:
                litter.box.length > 0
                    ? litter.box
                    : [
                          [0, 0],
                          [1, 1],
                      ],
            userTags: litter.userTags,
        };
    });

    // format bounding boxes for <BoundingBox />
    const formattedBoundingBoxes = boundingBoxData.map((litter) => [
        litter.box[0][0],
        litter.box[0][1],
        litter.box[1][0] - litter.box[0][0],
        litter.box[1][1] - litter.box[0][1],
    ]);

    // format bounding boxes into annotations for <LabelStudioUI />
    const labelStudioBoundingBoxes = generatePreAnnotations(boundingBoxData);

    const handleModal = () => {
        setOpen(!open);
    };

    return (
        <>
            <div className="my-4 content-box challengesContentCard">
                <div className="listGroup">
                    <BoundingBox
                        image={imageThumbnail}
                        boxes={formattedBoundingBoxes || []}
                        options={{
                            style: {
                                maxWidth: '200px',
                                maxHeight: '200px',
                            },
                        }}
                    />
                    <div className="challengesCardContent grid">
                        <div className="card-header">
                            <p>
                                <strong>Number of Litters:</strong>{' '}
                                {litterCount}
                            </p>
                            <p>
                                <strong>City:</strong> {city}
                            </p>
                            <p>
                                <strong>Country:</strong> {country}
                            </p>
                            <p>
                                <strong>Long, Lat:</strong> {latLong}
                            </p>
                            <p>
                                <strong>Created:</strong> {createdDate}
                            </p>
                        </div>
                    </div>
                    <div style={{ justifyContent: 'flex-end' }}>
                        <button
                            onClick={handleModal}
                            className="btn btn-primary"
                        >
                            Edit Tags
                        </button>
                    </div>
                </div>
            </div>
            <div className="container">
                <Modal
                    className="studioModal"
                    show={open}
                    onHide={() => setOpen(false)}
                    centered={true}
                    animation={true}
                    size="xl"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Tags</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <LabelStudioUI
                            imageLocation={imageThumbnail}
                            boundingBoxData={labelStudioBoundingBoxes || []}
                            taxonomy={props.taxonomy}
                            imageId={props.imageId}
                        />
                    </Modal.Body>
                </Modal>
            </div>
        </>
    );
}

ImageCard.propTypes = {
    data: PropTypes.object,
    taxonomy: PropTypes.object,
    imageId: PropTypes.number,
};

ImageCard.defaultProps = {
    imageId: '',
    data: {
        thumbnail: '',
    },
    taxonomy: {
        object: [],
        material: [],
        brand: [],
    },
};

export default ImageCard;
